import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {loginUser, logoutUser} from '../actions/authentication';
import { changeCulture } from '../actions/general';
import { getCulture } from '../actions/culture';
import {batchesUrl} from '../actions/router';
import Login from '../components/Login';
import { withBackgroundHeightAdjust } from '../components/WithBackgroundHeightAdjust';

const mapStateToProps = (state) => {
    return {
        authenticated: state.authentication.authenticated,
        culture: getCulture(state),
        customerId: state.general.customerId,
        customerBranding: state.general.customerBranding,
        languages: state.general.languages,
        error: state.authentication.error,
        urls: {
            batches: batchesUrl()
        }
    };
};

const mapDispatchToProps = (dispatch) => {    
    return {
        onSubmit: function(username, customerId, culture) {
            dispatch(loginUser(username, customerId, culture));
        },
        onCultureChange: function(culture) {
            dispatch(changeCulture(culture));
        },
		onLogout: function () {
			dispatch(logoutUser());
		},
    };
};

const LoginContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(withBackgroundHeightAdjust(Login)));

export default LoginContainer;